import React from 'react';

/**
 * Logo component for Hisham Al-Khayat Law Firm
 * @param {Object} props
 * @param {string} props.size - Size variant: 'sm' | 'md' | 'lg'
 * @param {string} props.className - Additional CSS classes
 */
export const Logo = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
    xl: 'w-12 h-12',
  };

  return (
    <img
      src="/logo-new.jpg"
      alt="مجموعة المحامي هشام يوسف الخياط"
      className={`${sizeClasses[size]} object-contain rounded ${className}`}
      data-testid="company-logo"
    />
  );
};

export default Logo;
